import script from "./SpecialDayEditorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialDayEditorModal.vue?vue&type=script&setup=true&lang=js"

import "./SpecialDayEditorModal.vue?vue&type=style&index=0&id=633125a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633125a6"]])

export default __exports__